"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleDropOffServiceItemEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const VehicleDropOffServiceItemDto_1 = require("../vehicle-drop-off-service-items/VehicleDropOffServiceItemDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class VehicleDropOffServiceItemEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, vehicleDropOffServiceItem) {
        super();
        this._requiredFieldsSetStatus = {
            vehicleDropOffId: false,
            name: false,
            desc: false,
            itemStatus: false,
            price: false,
            accepted: false
        };
        this._dependencies = dependencies;
        if (vehicleDropOffServiceItem === undefined) {
            this._dto = new VehicleDropOffServiceItemDto_1.VehicleDropOffServiceItemDto();
        }
        else if (vehicleDropOffServiceItem instanceof VehicleDropOffServiceItemDto_1.VehicleDropOffServiceItemDto) {
            this._dto = new VehicleDropOffServiceItemDto_1.VehicleDropOffServiceItemDto(vehicleDropOffServiceItem);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(false);
        }
        else if (vehicleDropOffServiceItem instanceof VehicleDropOffServiceItemEntity) {
            this._dto = new VehicleDropOffServiceItemDto_1.VehicleDropOffServiceItemDto(vehicleDropOffServiceItem._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(false);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new VehicleDropOffServiceItemDto_1.VehicleDropOffServiceItemDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getVehicleDropOffId() {
        return this._dto.vehicleDropOffId;
    }
    setVehicleDropOffId(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            _untrustedValue = untrustedValue;
        }
        else {
            _untrustedValue = parseInt(untrustedValue, 11);
        }
        if (_untrustedValue === this._dto.vehicleDropOffId) {
            return;
        }
        this.clearError("vehicleDropOffId");
        this._requiredFieldsSetStatus.vehicleDropOffId = true;
        if (_untrustedValue === undefined ||
            _untrustedValue === null ||
            !Number.isInteger(_untrustedValue) ||
            _untrustedValue <= 0) {
            this.addError(new ValidationError_1.ValidationError("vehicleDropOffId", "Vehicle Drop Off Id is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.vehicleDropOffId) {
            return;
        }
        this._dto.vehicleDropOffId = _untrustedValue;
        this._setIsDirty(true);
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.name) {
            return;
        }
        this.clearError("name");
        this._requiredFieldsSetStatus.name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("name", "Name Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getDesc() {
        return this._dto.desc;
    }
    setDesc(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.desc) {
            return;
        }
        this.clearError("desc");
        this._requiredFieldsSetStatus.desc = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("desc", "Desc is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("desc", `Desc has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.desc) {
            return;
        }
        this._dto.desc = _untrustedValue;
        this._setIsDirty(true);
    }
    getItemStatus() {
        return this._dto.itemStatus;
    }
    setItemStatus(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.itemStatus) {
            return;
        }
        this.clearError("itemStatus");
        this._requiredFieldsSetStatus.itemStatus = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("itemStatus", "Item Status is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("itemStatus", `Item Status has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.itemStatus) {
            return;
        }
        this._dto.itemStatus = _untrustedValue;
        this._setIsDirty(true);
    }
    getPrice() {
        return this._dto.price;
    }
    setPrice(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.price) {
            return;
        }
        this.clearError("price");
        this._requiredFieldsSetStatus.price = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("price", "Price is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("price", `Price has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.price) {
            return;
        }
        this._dto.price = _untrustedValue;
        this._setIsDirty(true);
    }
    getAccepted() {
        return this._dto.accepted;
    }
    setAccepted(untrustedValue) {
        const maxLength = 1;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.accepted) {
            return;
        }
        this.clearError("accepted");
        this._requiredFieldsSetStatus.accepted = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("accepted", "Accepted is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("accepted", `Accepted has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.accepted) {
            return;
        }
        this._dto.accepted = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.vehicleDropOffServiceItemDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Vehicle Drop Off Service Item is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.vehicleDropOffServiceItemDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.vehicleDropOffServiceItemDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Vehicle Drop Off Message cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.vehicleDropOffServiceItemDatastore.removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.VehicleDropOffServiceItemEntity = VehicleDropOffServiceItemEntity;
//# sourceMappingURL=VehicleDropOffServiceItemEntity.js.map